import { get } from 'lodash';
import { extractBalances, filterSelected } from '../../utils/accountUtils';
import { getFormattedPayees } from '../payees/selectors';
import { getSelectedFromAccount } from '../payeeSelector/selectors';
import { getPaymentTypeOrPayeeType, isChaps, isIFT, getIsLCV } from '../modes/selectors';
import {
	TYPE_FASTER_PAYMENTS,
	benTypes,
	TYPE_CHAPS,
	TYPE_BACS_CREDIT,
	TYPE_BACS_DEBIT,
	TYPE_IFT,
	TYPE_IFT_PAYEE,
	TYPE_DOMESTIC_PAYEE,
} from '../../config';
import { ACCOUNT_PICKER_LAYOUT, PAYEE_PICKER_LAYOUT } from '../../pickerLayout/constants';

export const getAccountsForCurrentPage = (state = {}) => {
	const accounts = get(state, 'accountPaging.accounts', []);
	const favourites = get(state, 'accountPaging.favourites.accounts', []);

	return filterSelected(accounts, [getSelectedFromAccount(state)]).map((account) => ({
		...account,
		isFavourite: favourites.some(({ id }) => id === account.id),
		...extractBalances(account),
	}));
};

export const getPayeesForCurrentPage = (state) => {
	const payees = get(state, 'accountPaging.payees');
	return payees.map((payee) => ({
		...payee,
		...getFormattedPayees(payee),
	}));
};

export const getPageLoading = (state) => state.accountPaging.loading;

export const getErrorFlag = (state) => state.accountPaging.error;

export const getPagingLayoutType = (state) => get(state, 'accountPaging.layoutType');

export const getShowPayees = (state) => get(state, 'accountPaging.payeesMetaData.showPayees');
export const getPayeesNeverFetched = (state) => get(state, 'accountPaging.payeesMetaData.payeesNeverFetched');

export const isAccountsPagingLayout = (state) =>
	getPagingLayoutType(state) === ACCOUNT_PICKER_LAYOUT || !getShowPayees(state);

export const isSelectingLCVFromAccount = (state) => get(state, 'accountPaging.isSelectingLCVFromAccount', false);

export const getPagingMetaData = (state) => {
	if (isAccountsPagingLayout(state)) {
		return get(state, 'accountPaging.accountsMetaData');
	}
	return get(state, 'accountPaging.payeesMetaData');
};

export const getCurrentFilterCriteria = (state) => {
	const { pageSize, currentPage, searchText } = getPagingMetaData(state);
	return {
		currentPage,
		pageSize,
		searchText,
	};
};

export const getCurrentPageInfo = (state) => {
	const { pageSize, totalNumberOfPages, currentPage, searchText } = getPagingMetaData(state);
	return {
		pageSize,
		totalNumberOfPages,
		currentPage,
		searchText,
	};
};

export const getLastApiAction = (state) => state.accountPaging.lastFailedApiAction;

export const getSearchText = (state) => {
	const { searchText = '' } = getPagingMetaData(state);
	return searchText;
};

export const getAccountsNeverFetched = (state) => state.accountPaging.accountsNeverFetched;

export const getTotalNumberOfAccounts = (state) => get(state, 'accountPaging.total_number_of_accounts');

export const getBenType = (state) => {
	const paymentTypeOrPayeeType = getPaymentTypeOrPayeeType(state);
	switch (paymentTypeOrPayeeType) {
		case TYPE_FASTER_PAYMENTS:
		case TYPE_CHAPS:
		case TYPE_BACS_CREDIT:
		case TYPE_BACS_DEBIT:
		case TYPE_DOMESTIC_PAYEE:
			return benTypes.UK;
		case TYPE_IFT:
		case TYPE_IFT_PAYEE:
			return benTypes.IFT;
		default:
			return benTypes.ALL;
	}
};

export const getShowPayeePickerToggle = (state) => !(isChaps(state) || isIFT(state));
export const getShowFavouritesToggleInPayeePicker = (state) =>
	getPagingLayoutType(state) === PAYEE_PICKER_LAYOUT && getIsLCV(state);

export const isFavouritesEnabled = (state) => {
	if (getPagingLayoutType(state) === PAYEE_PICKER_LAYOUT && !getIsLCV(state)) {
		return false;
	}
	return true;
};

export const getIsAccountsSearchFilterOn = (state) =>
	get(state, 'accountPaging.accountsMetaData.isSearchFilterOn', false);
export const getIsPayeesSearchFilterOn = (state) => get(state, 'accountPaging.payeesMetaData.isSearchFilterOn', false);
